// Generic error envelope. The auth + api services both return
// { error, request_id, retry_after_seconds?, detail? } on failure.
// The class is the only thing client code throws/inspects.

export class ApiError extends Error {
  constructor(
    public readonly code: string,
    public readonly status: number,
    public readonly requestId?: string,
    public readonly retryAfterSeconds?: number,
    public readonly detail?: string,
  ) {
    super(code);
    this.name = 'ApiError';
  }
}
